import { api } from './api';

export type BuildHintStatus = 'open' | 'done' | 'dismissed';
export type BuildHintSource = 'agentic' | 'manual' | 'mcp';

export interface BuildHint {
  id: string;
  change: string;
  source: BuildHintSource;
  trigger?: 'asked' | 'relevant';
  confidence: number;
  evidenceSeq: number[];
  quotes: string[];
  reasoning?: string;
  repeats?: number;
  status: BuildHintStatus;
  note?: string | null;
  updatedBy?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface BuildHintList {
  hints: BuildHint[];
  counts: Record<BuildHintStatus, number>;
  cursor: string | null;
}

export const buildHintsService = {
  async list(sessionId: string, since?: string): Promise<BuildHintList> {
    const res = await api.get(`/api/sessions/${sessionId}/build-hints`, { params: { status: 'all', ...(since ? { since } : {}) } });
    return res.data;
  },

  async create(sessionId: string, change: string): Promise<BuildHint> {
    const res = await api.post(`/api/sessions/${sessionId}/build-hints`, { change });
    return res.data;
  },

  async update(sessionId: string, hintId: string, patch: { change?: string; status?: BuildHintStatus; note?: string }): Promise<BuildHint> {
    const res = await api.patch(`/api/sessions/${sessionId}/build-hints/${encodeURIComponent(hintId)}`, patch);
    return res.data;
  },
};
